import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ModulosFunctions} from "./ModulosFunction";

@Injectable()
export class TokenValidatorService implements CanActivate
{
  constructor(private router: Router, private model: ModulosFunctions) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {

    var accessToken =  localStorage.getItem("accessToken");

    if (!accessToken)
    {
      this.router.navigate(['/externo']);
      return false;
    }else{
      return this.model.checkUrlModuloExterno(route, accessToken);
    }
  }
}
